import {
    Injectable,
    NgModule,
    Pipe,
    PipeTransform,
    inject,
} from '@angular/core';
import { UtilService } from '../services';
import { isNil as _isNil } from 'lodash';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'formatNumber' })
export class FormatNumberPipe implements PipeTransform {
    private utilService = inject(UtilService);

    transform(value: any, ...args: any[]): string {
        if (_isNil(value)) {
            return '';
        }
        const inputNumber = this.utilService.localStringToNumber(value);
        return inputNumber.toLocaleString(undefined, {
            minimumFractionDigits: args[0] || 0,
            maximumFractionDigits: args[0] || 0,
        });
    }
}

@NgModule({
    imports: [FormatNumberPipe],
    exports: [FormatNumberPipe],
})
export class FormatNumberPipeModule {}
